<template>
<div class="crud">
  <the-crud :title="title" :store="store" :columns="columns" :search="search" :canDelete="true">
  </the-crud>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import TheCrud from '@/components/crud/TheCrud'
export default {
  components : {
    TheCrud
  },
  data() {
    return {
      closeModal : true,
      server : null,
      confirmationValue: '',
      confirmationMessage: '',
      title : this.$t("configuration.servers.ostickets.title"),
      store : 'ostickets',
      search : ['name'],
      columns : [
        { index : 'id', label : '#id', sortable : true},
        { index : 'name', label : this.$t('configuration.servers.name') },
        { index : 'address', label : this.$t('configuration.servers.ostickets.address') },
        { index : 'restApiAddress', label : this.$t('configuration.servers.ostickets.api_address') },
        { index : 'adminUsername', label : this.$t('configuration.servers.ostickets.username'), 'hide in table': true },
        { index : 'passwordUsername', label : this.$t('configuration.servers.ostickets.password'), 'hide in table': true },
      ],
    }
  },
  computed : {
    ...mapGetters(['isAdmin']),
  }
}
</script>

<style>

</style>